import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
import { createBrowserHistory } from 'history';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import MarcaController from '../../../../controllers/MarcaController';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

export default function MarcaCadastrar() {
  const { userId } = useSelector((state: any) => state.Authentication);

  const history = createBrowserHistory();
  const [single, setSingle] = useState<any>(null);
  const { id } = useParams()
  const MarcaId = id ? parseInt(id) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {
    if (MarcaId !== null && MarcaId !== undefined) {
      getSingle(MarcaId);
    }
  }, [MarcaId]);

  const getSingle = async (MarcaId: number) => {
    const Response = await MarcaController.ListarUnico(MarcaId);

    setSingle(Response.Data);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (MarcaId === null) {
      const response = await MarcaController.Adicionar(values);

      if (response.StatusCode === 204) {
        toast('Marca incluido com sucesso!', {
          type: 'success',
        })
        resetForm();
      } else {
        toast('Erro ao incluir o marca!', {
          type: 'error',
        })
        resetForm();
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      MarcaId: MarcaId,
      ...values,
    };

    const response = await MarcaController.Atualizar(request);

    if (response.StatusCode === 204) {
      toast('Marca atualizado com sucesso!', {
        type: 'success',
      })
    } else {
      toast('Erro ao atualizar a marca!', {
        type: 'error',
      })
    }

    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    Descricao: single?.mar_descricao || '',
  };

  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatorio!')
      .min(4, 'O Campo deve ter no minimo 4 caracteres'),
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO DE MARCAS'} className={'mb-5'} />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form>
            <BoxButtons>
              <Button
                variant='contained'
                onClick={() => history.back()}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>
            <fieldset disabled={duploClick}>
            <Field
              name='Descricao'
              required
              as={TextField}
              label='Descrição'
              placeholder=''
              type='text'
              error={Boolean(errors?.Descricao)}
              helperText={errors?.Descricao}
            />
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
